import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { ConditionalWrapper } from '@cian/conditional-component';
/**
 * @todo move from deprecated typography to new one
 * @see {@link https://jira.cian.tech/browse/CD-163108}
 */
import { Header0, ArticleHeading1, UIText1 } from '@cian/ui-kit/typography';
import { Button } from '@cian/ui-kit/button';

import { NBSP } from '../../constants/symbols';

import * as styles from './styles.css';

export interface IIntroProps {
  submitText?: string;
  onSubmit(): void;
}

export function Intro({ submitText = 'Заполнить анкету', onSubmit }: IIntroProps) {
  const isMobile = !useIsDesktop();

  return (
    <div className={styles['container']}>
      <div>
        {isMobile && <div className={styles['img']} />}
        <div className={styles['title']}>
          <ConditionalWrapper if={isMobile} ThenComponent={ArticleHeading1} ElseComponent={Header0}>
            <span>
              Бесплатно подберем
              <br />
              надежного риелтора
            </span>
          </ConditionalWrapper>
        </div>
        <ul className={styles['list']}>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <UIText1>1</UIText1>
            </span>
            <UIText1>
              Заполните короткую анкету. Это{NBSP}займет не{NBSP}более 3{NBSP}минут
            </UIText1>
          </li>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <UIText1>2</UIText1>
            </span>
            <UIText1>Мы отправим анкету риелторам, которые{NBSP}сотрудничают с нами</UIText1>
          </li>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <UIText1>3</UIText1>
            </span>
            <UIText1>
              Вам позвонит не более 3 риелторов. Они{NBSP}уточнят детали и{NBSP}ответят на{NBSP}вопросы
            </UIText1>
          </li>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <UIText1>4</UIText1>
            </span>
            <UIText1>
              Вы{NBSP}обсудите условия сотрудничества,{NBSP}стоимость услуг и{NBSP}выберите подходящего риелтора
            </UIText1>
          </li>
        </ul>
        <div className={styles['button-sticky']} data-testid="quizStart">
          <Button theme="fill_primary" size="M" onClick={onSubmit} fullWidth={isMobile}>
            {submitText}
          </Button>
        </div>
      </div>
    </div>
  );
}
